<div class="card-base">
    <div class="card-content-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-medical-fee-filter #filters></app-medical-fee-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <p-scrollPanel styleClass="scroll-panel">
                    <table class="search-table" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="Number">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Numero</th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div><b>{{ element.Id }}</b></div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Amount">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Importe</th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div><b>{{ element.Amount }}</b></div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Date">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Fecha</th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div><b>{{ element.Date  | date:'dd/MM/yyyy' }}</b></div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="MedicalFeePeriodName">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Período</th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div><b>{{ element.MedicalFeePeriodName }}</b></div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="PayDate">
                            <th mat-header-cell class="table-header" *matHeaderCellDef> Fecha pago</th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <div><b>{{ element.PayDate | date:'dd/MM/yyyy' }}</b></div>
                            </td>
                        </ng-container>


                        <!-- Star Column -->
                        <ng-container matColumnDef="Action" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <mat-spinner *ngIf="loadingAction" [diameter]="15"></mat-spinner>
                                <button *ngIf="!loadingAction" mat-icon-button [matMenuTriggerFor]="menuItem">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item (click)="viewReport(element)"><mat-icon></mat-icon><span>Ver</span></button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>